export default __webpack_public_path__ + "static/media/bizzLink.d3bc3b07.png";